import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=12660aae&scoped=true&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"
import style0 from "./CTA.vue?vue&type=style&index=0&id=12660aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12660aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12660aae')) {
      api.createRecord('12660aae', component.options)
    } else {
      api.reload('12660aae', component.options)
    }
    module.hot.accept("./CTA.vue?vue&type=template&id=12660aae&scoped=true&", function () {
      api.rerender('12660aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CTA.vue"
export default component.exports